module.exports = __webpack_public_path__ + "assets/icSecurity.4e0e9486.svg";